import React from "react";
import {
  ButtonSvgOutlineLg,
  ButtonSvgOutlineHoverLg,
} from "../../utils/constants";
import { useNavigate } from "react-router-dom";

export default function DetailCard({
  icon,
  title,
  detail,
  url,
  urlTarget,
  btn,
}) {
  const navigate = useNavigate()
  const handleBtnClick = (url) => {
    console.log({url})
    if (url?.includes("https")){
      window.open(url, "_blank")
    } else{
      navigate(url)
    }
  }
  return (
    <div className="relative h-full w-full duration-300 max-w-[360px] mx-auto flex flex-col justify-between gap-3 lg:gap-2">
      <div className="flex flex-col gap-5 lg:gap-4">
        <div className="laptop:min-h-[280px] xxl:min-h-[340px] h-full w-full">
          <img src={icon} alt={title} className="object-cover" />
        </div>
        <div className="relative flex flex-col gap-3 lg:gap-2">
          <h3 className="text-black text-[18px]/4 lg:text-xxl/6 font-bold font-serif tracking-[-4%] mb-0">
            {title}
          </h3>
          <p className="text-black text-[14px]/4 lg:text-sm/6 font-medium font-serif tracking-[-0.30px] lg:tracking-[-0.64px]">
            {detail}
          </p>
        </div>
      </div>

      <div className="flex flex-wrap gap-4">
        <button className="inline-flex items-center text-[12px]/3 lg:text-[14px]/[16px] font-bold duration-300 cursor-pointer uppercase font-sans whitespace-nowrap px-4 pb-2 borderBtn !p-0 group max-w-[180px] lg:max-w-[220px]"
         onClick={()=>handleBtnClick(url)}>
          <span className="inactive">
            <ButtonSvgOutlineLg />
          </span>
          <span className="active">
            <ButtonSvgOutlineHoverLg />
          </span>
          <span className="btnTxt !bg-[#1C1B25] gradient-text group-hover:bg-textGd lg:left-6">
            {btn}
          </span>
        </button>
        {/* <CustomLink
          url={url}
          target={urlTarget}
          className="borderBtn !p-0 group max-w-[180px] lg:max-w-[220px]"
        >
          <span className="inactive">
            <ButtonSvgOutlineLg />
          </span>
          <span className="active">
            <ButtonSvgOutlineHoverLg />
          </span>
          <span className="btnTxt !bg-[#1C1B25] gradient-text group-hover:bg-textGd  lg:left-6">
            {btn}
          </span>
        </CustomLink> */}
      </div>
    </div>
  );
}
